import { Button } from "antd";
import { ModalButton } from "../../../components/ModalButton";
import {
	type Theme,
	getColor,
	getSize,
	getWeight,
} from "views/resources/theme";
import { Wait, Waiting } from "../icons";
import { getOrElse } from "../../../util.js";
import React from "react";
import Skeleton from "react-loading-skeleton";
import moment from "moment-timezone";
import styled from "styled-components";

export const ReserveCard2 = ({
	officeName,
	downloadReserveAction,
	type,
	code,
	name,
	datetime,
	onClick,
	loading,
	message,
}) => (
	<WrapperDesktop>
		<Wrapper>
			<BotView>
				<div>
					<span>Número de reserva:</span>
				</div>
				<h1>{code}</h1>
				<div>
					<span>Nombre de fila:</span>
					<h4>{name}</h4>
				</div>
				<div className="status">Hora de reserva:</div>
				<div className="timestamp">{datetime}</div>
				<ButtonWrapper>
					<button onClick={loading ? () => {} : onClick}>
						{loading ? "Cargando" : "Cancelar reserva"}
					</button>
				</ButtonWrapper>
				{message && <Message>Nota: {message}</Message>}
			</BotView>

			<div className="button__ticket-screen">
				<ModalButton
					onClick={() =>
						downloadReserveAction(
							name,
							code,
							datetime,
							type,
							officeName
						)
					}
					loading={false}
					type={"primary"}
					label="Descargar reservación"
				/>
			</div>
		</Wrapper>
	</WrapperDesktop>
);

const Message = styled.div`
	padding: 30px;
	font-size: 12px;
`;

const ReserveCard = ({ line, reserve, tz, onClick }) => {
	const Reserve = getOrElse(reserve, <Skeleton width="50%" />);
	const Line = getOrElse(line, <Skeleton width="50%" />);
	return (
		<Wrapper>
			<BotView>
				<div>
					<span>Número de reserva:</span>
				</div>
				<Reserve>{(r) => <h1>RV {formatReserveId(r.id)}</h1>}</Reserve>
				<div>
					<span>Nombre de fila:</span>
					<h4>
						{reserve.map((r) => (
							<div>{r.lineName}</div>
						))}
						<Line>{(l) => l.name}</Line>
					</h4>
				</div>
				<div className="status">Hora de reserva:</div>
				<Reserve>
					{(r) => (
						<div className="timestamp">
							{formatTime(r.from, tz)}
						</div>
					)}
				</Reserve>
				<ButtonWrapper>
					<button onClick={onClick}>Cancelar reserva</button>
				</ButtonWrapper>
			</BotView>
		</Wrapper>
	);
};

// this accounts for v1 and v2 reservation formats
const formatReserveId = (id) => {
	if (Number.isInteger(id)) return id.toString().split("").slice(-3).join("");
	if (typeof id === "string" || id instanceof String)
		return id.substr(id.length - 3);
	throw new Error("unrecognized reserve id input");
};

const formatTime = (time, tz) => {
	const reserve_from = moment.tz(moment.utc(time), tz);
	return `${reserve_from.format("L")} a las ${reserve_from.format("HH:mm")}`;
};

const BotView = styled.div`
	padding: 19px 0 21px;
	text-align: center;
	margin: 0;
	h1 {
		color: ${getColor("primary")};
		margin: 0;
		color: #145ab4;
		font-family: Roboto;
		font-size: 43px;
		font-weight: 900;
	}

	h2 {
		color: ${getColor("primary")};
		font-size: 16px;
		margin: 0;
	}

	span {
		font-weight: ${getWeight("medium")};
		color: ${getColor("fg")};
	}
`;

const ButtonWrapper = styled.div`
	margin-top: 20px;
	button {
		cursor: pointer;
		padding: 10px 25px;
		color: ${getColor("secondary")};
		background: transparent;
		border-radius: 10px;
		font-size: 14px;
		border-color: ${getColor("secondary")};
	}
`;

const WrapperDesktop = styled.div`
	width: 100%;
	max-width: 460px;
`;

const Wrapper: StyledComponent<*, Theme, *> = styled.div`
	mask: radial-gradient(
			circle at left 86px,
			transparent,
			transparent 20px,
			white 22px,
			white 80%,
			transparent 80%,
			transparent
		),
		radial-gradient(
			circle at right 86px,
			transparent,
			transparent 20px,
			white 22px,
			white 80%,
			transparent 80%,
			transparent
		);
	mask-size: 100% 100%;
	border-radius: ${getSize("s")};
	background-color: ${getColor("elementBg")};
	margin: 0;
	position: relative;
	overflow: hidden;

	.status {
		color: ${getColor("primary_light")};
	}

	.timestamp {
		font-size: ${getSize("sm")};
		font-weight: ${getWeight("semibold")};
	}
	.button__ticket-screen {
		width: 100%;
		padding-bottom: 12px;
		& button {
			width: 80%;
			margin: 0 auto;
		}
	}
`;

export default ReserveCard;
